import { render, staticRenderFns } from "./PdpV2.vue?vue&type=template&id=26bc670c&scoped=true&"
import script from "./PdpV2.vue?vue&type=script&lang=js&"
export * from "./PdpV2.vue?vue&type=script&lang=js&"
import style0 from "./PdpV2.vue?vue&type=style&index=0&id=26bc670c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bc670c",
  null
  
)

export default component.exports